__turbopack_context__.v({
  "label": "AlphaLabel-module-scss-module__C8lY-a__label",
  "learnMoreLink": "AlphaLabel-module-scss-module__C8lY-a__learnMoreLink",
  "tooltipContent": "AlphaLabel-module-scss-module__C8lY-a__tooltipContent",
});
